<template>

	<div>
		<div class="header-item">
			<template v-if="mainslug === 'users'">
				<router-link :to="`/${mainslug}`" class="btn-back"></router-link>
				<h1>Edit <i>user</i></h1>
			</template>
			<template v-else-if="mainslug === 'roles'">
				<router-link :to="`/users/${mainslug}`" class="btn-back"></router-link>
				<h1>Edit <i>role</i></h1>
			</template>
			<template v-else-if="mainslug === 'pages'">
				<router-link :to="`/pages`" class="btn-back"></router-link>
				<h1>Edit <i>page</i></h1>
			</template>
			<template v-else>
				<router-link :to="`/${mainslug}/${entityid}`" class="btn-back"></router-link>
				<!-- <h1 v-if="objectName">Edit <i>{{objectName}}</i></h1> -->
				<DropDown :title="objectName" :mainslug="mainslug" :content="filtered" :edit="true"></DropDown>
			</template>
		</div>

		<div class="white">
			<div class="row">
				<div class="col-20">

					<div class="toolbar">
						<nav class="subnav">
							<ul>
								<li><router-link :to="`/${mainslug}/${entityid}/edit/${id}/content`">Content</router-link></li>
								<!-- <li><router-link :to="`/content/${entityid}/edit/${id}/metadata`">Metadata</router-link></li> -->
								<!-- Don't show the langswitch for users and roles -->
								<li v-if="entityid != 24 && entityid != 25">
									<LangSwitch type="multiple" v-bind:downloadCallback="getMarketsCompleteHandler"></LangSwitch>
								</li>
							</ul>
						</nav>
					</div>

				</div>
			</div>
		</div>

		<router-view :entities="content" :markets="markets"></router-view>

	</div>

</template>

<script>

import DropDown from '../../components/DropDown.vue'
import LangSwitch from '../../components/LangSwitch.vue'
import xhrModule from '../../modules/xhrModule.js'

export default {
	name: 'edit-object',
	props: {
		content: Array,
		filtered: Array
	},

	watch: {
		content: function (newVal, oldVal) {
			this.setActiveEntityInHeader(newVal)
		}
	},

	data () {
		return {
			entityid: this.$route.params.entityid,
			id: this.$route.params.id,
			objectName: null,
			mainslug: this.getMainSlug(),
			markets: null
		}
	},

	components: {
		'LangSwitch': LangSwitch,
		'DropDown': DropDown
	},

	created () {
		this.entityid = this.$route.params.entityid
		this.id = this.$route.params.id

		this.setActiveEntityInHeader(this.content)

		if (this.entityid == 24 || this.entityid == 25) {
			// download markets because there is no langswitch
			var url = '/cms/api/markets'
			xhrModule.get(url, this.fetchedMarketsCompleted.bind(this))
		}
	},

	methods: {
		fetchedMarketsCompleted: function (data) {
			this.markets = data.data
		},

		getMarketsCompleteHandler (data) {
			this.markets = data
		},

		setActiveEntityInHeader (content) {
			if (!content) return
			for (var i = content.length - 1; i >= 0; i--) {
				if (content[i].id === parseInt(this.entityid)) {
					this.objectName = content[i].translations.en.value
				}
			}
		},

		getMainSlug () {
			var pathName = window.location.pathname
			return pathName.split('/')[1]
		}
	}
}

</script>
